export const version = "abi/5.6.2";
//# sourceMappingURL=_version.js.map